import { useMembersStore } from "../stores/useMembersStore";
import { InfiniteScrollList } from "../components/core/InfiniteScrollList";
import { MemberListCard } from "../components/list-cards/members/MemberListCard";
import { MemberListCardSkeleton } from "../components/list-cards/members/MemberListCardSkeleton";
import { useTranslation } from "react-i18next";
import { membersApi } from "../api/members.api";
import { Title } from "@/components/core/Title";
import { ListFiltering } from "@/components/core/InfiniteScrollList/ListFiltering";
import { PageContainer } from "@/components/core/PageContainer";
import { useLocation } from "react-router-dom";
import { useRefreshOnLocationChange } from "@/hooks/useRefreshOnLocationChange";
import { useDisableLocationSelection } from "@/hooks/useDisableLocationSelection";

export function Members() {
  const { t } = useTranslation();
  const store = useMembersStore();
  const location = useLocation();

  // Check if we came from the charge button
  const isChargeFlow = location.state?.fromChargeButton;

  useDisableLocationSelection(isChargeFlow);

  useRefreshOnLocationChange(store);

  return (
    <PageContainer asList>
      <Title>
        {isChargeFlow ? t("members.selectMemberToCharge") : t("members.title")}
      </Title>

      <ListFiltering
        store={store}
        placeholder={t("members.searchPlaceholder")}
      />

      <div className="flex-1 min-h-0">
        <InfiniteScrollList
          store={store}
          renderItem={(props) => (
            <MemberListCard {...props} isChargeFlow={isChargeFlow} />
          )}
          renderSkeleton={MemberListCardSkeleton}
          queryKey={["members"]}
          queryFn={membersApi.fetchMembers}
          emptyState={{
            image: "/images/empty-states/members-empty-state.png",
            title: t("members.emptyState.title"),
          }}
        />
      </div>
    </PageContainer>
  );
}
